// extracted by mini-css-extract-plugin
module.exports = {"popular-search-row":"PopularSearch_popular-search-row__2EpLe","popular-search-item":"PopularSearch_popular-search-item__3ltJg"};